import {
  startRegistration,
  startAuthentication,
} from "@simplewebauthn/browser";
import { portalApi } from "../lib/portalApiClient";

export const physicianPasskeyService = {
  async getRegistrationOptions(invitationToken: string) {
    return portalApi.post<any>("/auth/register/passkey/options", {
      invitationToken,
    });
  },

  async registerPasskey(
    invitationToken: string,
    deviceName: string
  ): Promise<{
    sessionToken: string;
    email: string;
    practiceNames: string[];
  }> {
    const { options, challengeKey } = await this.getRegistrationOptions(
      invitationToken
    );
    const credential = await startRegistration({ optionsJSON: options });
    return portalApi.post("/auth/register/passkey/verify", {
      invitationToken,
      credential,
      deviceName,
      challengeKey,
    });
  },

  async getLoginOptions(email?: string) {
    return portalApi.post<any>("/auth/passkey/login/options", { email });
  },

  async loginWithPasskey(email?: string): Promise<{
    sessionToken: string;
    email: string;
    practiceNames: string[];
  }> {
    const { options, challengeKey } = await this.getLoginOptions(email);
    const credential = await startAuthentication({ optionsJSON: options });
    return portalApi.post("/auth/passkey/login/verify", {
      email,
      credential,
      challengeKey,
    });
  },

  async addNewPasskey(deviceName: string): Promise<any> {
    const { options, challengeKey } = await portalApi.post<any>(
      "/account/passkeys/options",
      {}
    );
    const credential = await startRegistration({ optionsJSON: options });
    return portalApi.post("/account/passkeys/verify", {
      credential,
      deviceName,
      challengeKey,
    });
  },
};
